module.exports = __webpack_public_path__ + "img/bahaya.7abcbdcf.png";